import React, { useState , useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import {   EMPTY_OBJECT , userProfilePayload , validLicenceNumber , validPhone }  from '../../constants/globalConstants'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { updateUserProfile , getUserProfile } from '../../redux/actions/login'
import ResetPassWordModal from '../../components/global/ResetPassWordModal'
import { validateEmail } from '../../utils/helper'

import { Circles } from 'react-loader-spinner'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
const zipCodeMaskGenerator = createDefaultMaskGenerator('999999')


const UserProfile = (props) =>{
    const { dispatch } = props
     // modal state 
     const [isResetModalOpen, setResetModalOpen] = useState(false)
     const [edit, setEdit] = useState(false)
     const [userData, setUserData] = useState(EMPTY_OBJECT)
     const [images, setImages] = useState({})
     const [userUpdatePayload, setUserUpdatePayload] = useState(userProfilePayload)
    //  const [resident, setResident] = useState('')
    //  const [disclaimerNote, setDisclaimerNote] = useState('')
     const [error, setError] = useState(false)
     const [errorMessage, setErrorMessage] = useState(EMPTY_OBJECT)
     const [isUpdatingProfile, setIsUpdatingProfile] = useState(false)
    //  const [idProof, setIdProof] = useState(EMPTY_ARRAY)


 
    useEffect(() => {  
        dispatch(getUserProfile()).then((res) => {
            if (res) {
                // setResident(res?.resident_status)
                const userProfileData = JSON.parse(localStorage.getItem('userData'))
                userProfileData.user = res
                if (userProfileData) {
                    localStorage.setItem('userData', JSON.stringify(userProfileData))
                } else {
                    localStorage.setItem('userData', '{}')
                }
                setUserData(res)
                images['front'] = res?.permit?.[0]?.idfront
                images['back'] = res?.permit?.[0]?.idback
                setImages({ ...images })
                if (res?.name !== '') {
                    const formdata = res
                    userUpdatePayload['name'] = formdata?.name ? formdata?.name?.trim() : ''
                    userUpdatePayload['license_number'] = formdata?.license_number ? formdata?.license_number?.trim() : ''
                    userUpdatePayload['email'] = formdata?.email ? formdata?.email?.trim() : ''
                    userUpdatePayload['phone'] = formdata?.phone_number ? formdata?.phone_number?.trim() : ''
                    userUpdatePayload['address'] = formdata?.address ? formdata?.address?.trim() : ''
                    userUpdatePayload['address2'] = formdata?.address2 ? formdata?.address2?.trim() : ''
                    userUpdatePayload['city'] = formdata?.city ? formdata?.city?.trim() : ''
                    userUpdatePayload['state'] = formdata?.state ? formdata?.state?.trim() : ''
                    userUpdatePayload['zipcode'] = formdata?.pincode ? formdata?.pincode?.trim() : ''
                    setUserUpdatePayload({ ...userUpdatePayload })
                }
            }
        })
    }, [EMPTY_OBJECT])
   

    const handleModalOpen = (e) => {
        e.preventDefault()
        setResetModalOpen(true)
    }

    const handleEditMode = () => {
        setEdit(true)
    }

    const handlePhoneChange = (value) => {
        setUserUpdatePayload({ ...userUpdatePayload, ['phone']: value?.trim() })
    }

    const handleZipCodeChange = (value) => {
        setUserUpdatePayload({ ...userUpdatePayload, ['zipcode']: value?.trim() })
    }


    const handleUpdateUserProfile = (e) => {
 
        setError(true)
        setIsUpdatingProfile(true)
        e.preventDefault()
        let formData = new FormData()
        // formData.append('license_number', userUpdatePayload?.license_number)
        formData.append('email', userUpdatePayload?.email)
        formData.append('name', userUpdatePayload?.name)
        formData.append('phone', userUpdatePayload?.phone)
        formData.append('address', userUpdatePayload?.address)
        formData.append('address2', userUpdatePayload?.address2 ? userUpdatePayload?.address2 : '')
        formData.append('city', userUpdatePayload?.city)
        formData.append('state', userUpdatePayload?.state)
        formData.append('zipcode', userUpdatePayload?.zipcode)
        // formData.append('permit_id', userData?.permit?.[0]?.id)
 
        // if(idProof?.length > 0){
        //     idProof?.map((item) => {
        //         formData.append(item?.type, item?.file)
        //     })
        // }
        if (userUpdatePayload?.name != '' && userUpdatePayload?.license_number != '' && userUpdatePayload?.email != '' && userUpdatePayload?.phone != '') {
            if (validateEmail(userUpdatePayload?.email)) {
                if (validPhone.test(userUpdatePayload?.phone) && userUpdatePayload?.phone?.length == 10) {
                    if (validLicenceNumber.test(userUpdatePayload?.license_number?.trim())) {
                        dispatch(updateUserProfile(formData)).then((res) => {
                            setIsUpdatingProfile(false)
                            // setDisclaimerNote('')
                            const userProfileData = JSON.parse(localStorage.getItem('userData'))
                            userProfileData.user = res?.data?.user
                            userProfileData.permit = res?.data?.permit
                            if (userProfileData) {
                                if (res?.data?.permit?.idfront || res?.data?.permit?.idback) {
                                    images['front'] = res?.data?.permit?.idfront ? res?.data?.permit?.idfront : ''
                                    images['back'] = res?.data?.permit?.idback ? res?.data?.permit?.idback : ''
                                    setImages({ ...images })
                                }
                                localStorage.setItem('userData', JSON.stringify(userProfileData))
                            } else {
                                localStorage.setItem('userData', '{}')
                            }
                            setEdit(false)
                        }).catch(() => {
                            // setDisclaimerNote('')
                            setIsUpdatingProfile(false)
                            setErrorMessage({ message: 'Something went wrong, Please try again!' })
                        })
                    } else {
                        setIsUpdatingProfile(false)
                        setErrorMessage({ message: '' })
                    }

                } else {
                    setIsUpdatingProfile(false)
                    setErrorMessage({ message: '' })
                }
            } else {
                setIsUpdatingProfile(false)
                setErrorMessage({ message: '' })
            }

        } else {
            setIsUpdatingProfile(false)
            setErrorMessage({ message: '' })
        }
    }

    
    const handleInputChange = (e) => {
        const { name, value } = e.target

        // if (name == 'license_number') {
        //     userUpdatePayload[name] = value?.trim()?.toUpperCase()
        //     setUserUpdatePayload({ ...userUpdatePayload })

        //     if (value?.length > 6 && value?.length < 14) {
        //         if (value?.length != 9) {
        //             if (validLicenceNumber.test(value?.trim())) {
        //                 setResident('Non-Resident')
        //             } else {
        //                 setResident('Invalid License Number')
        //             }
        //         } else {
        //             const alpha = value?.slice(0, 1)
        //             const number = value?.slice(1, 9)
        //             if (/^[a-zA-Z]+$/.test(alpha) && /(\d{8})/g.test(number)) {
        //                 setResident('Resident')
        //             } else {
        //                 if (validLicenceNumber.test(value?.trim())) {
        //                     setResident('Non-Resident')
        //                 } else {
        //                     setResident('Invalid License Number')
        //                 }
        //             }
        //         }
        //     } else {
        //         // setResident('')
        //     }
            // if (userData?.license_number != value) {
            //     setDisclaimerNote('For New/Existing Permits, the revised rates will be applicable as per your new License number.')
            // } else {
            //     setDisclaimerNote('')
            // }
        // } else {
            userUpdatePayload[name] = value?.trim()
            setUserUpdatePayload({ ...userUpdatePayload })
        // }
    }



    return(
        <main>
            <section className="formDesign p-sm-5">
            <div className="container mb-3">
                    <div className="card mb-3">
                    <div className="card-header">
                            <div className="d-flex">
                                <h5 className="mb-0">Personal Information</h5>
                                <button className="btn btn-primary p-1 px-2 ms-auto me-1" type='button' onClick={(e) => handleModalOpen(e)}>Reset Password</button>
                                <button className="btn btn-secondary p-1 px-2" onClick={handleEditMode}> <i className="fa fa-pencil"></i></button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name <span style={{ color: 'red' }}>*</span></label>
                                        <input className="form-control" name='name' id='name' type='text' value={userData?.name ? userData?.name : ''} disabled />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.name ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email <span style={{ color: 'red' }}>*</span></label>
                                        <input className="form-control" id='email' name='email' type='email' value={userData?.email ? userData?.email : ''} disabled />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.email ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone Number <span style={{ color: 'red' }}>*</span></label>
                                        <MaskedInput
                                            maskGenerator={phoneMaskGenerator}
                                            value={userData?.phone_number ? userData?.phone_number : ''}
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            className="form-control"
                                            required
                                            // pattern="[0-9 \\-\(\)\]{14}"
                                            maxLength={14}
                                            minLength={14}
                                            title="Please enter a valid phone number"
                                            onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="Phone Number"
                                            onChange={handlePhoneChange}
                                            // onBlur={handlePhoneChange}
                                            disabled={!edit}
                                        />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.phone ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input className="form-control" id='address' name='address' defaultValue={userData?.address ? userData?.address : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} />
                                        {/* <span className="form-text text-danger h-40">{error && !userUpdatePayload?.address ? 'This field is required' : ''}</span> */}
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="address2" className="form-label">Address 2</label>
                                        <input className="form-control" id='address2' name='address2' defaultValue={userData?.address2 ? userData?.address2 : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} />
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City</label>
                                        <input className="form-control" name='city' id='city' defaultValue={userData?.city ? userData?.city : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} />
                                        {/* <span className="form-text text-danger h-40">{error && !userUpdatePayload?.city ? 'This field is required' : ''}</span> */}
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="state" className="form-label">State</label>
                                        <input className="form-control" name='state' id='state' defaultValue={userData?.state ? userData?.state : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} />
                                        {/* <span className="form-text text-danger h-40">{error && !userUpdatePayload?.state ? 'This field is required' : ''}</span> */}
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="zipcode" className="form-label">Zip Code</label>
                                        <MaskedInput
                                            maskGenerator={zipCodeMaskGenerator}
                                            value={userData?.pincode ? userData?.pincode : ''}
                                            type="text"
                                            name="zipcode"
                                            id="zipcode"
                                            className="form-control"
                                            required
                                            // pattern="[0-9 \\-\(\)\]{14}"
                                            maxLength={6}
                                            minLength={6}
                                            title="Please enter a valid zipcode"
                                            onInvalid={e => e.target.setCustomValidity('Please enter zipcode')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="Pin Code / Security Code"
                                            onChange={handleZipCodeChange}
                                            disabled={!edit}
                                        />
                                        {/* <span className="form-text text-danger h-40">{error && !userUpdatePayload?.zipcode ? 'This field is required' : ''}</span> */}
                                    </div>
                                </div>
                            </div>
                            
                            {errorMessage ? <span className='text-danger'>{errorMessage?.message ? errorMessage?.message : ''}</span> : ''}
                            {edit && <button type="button" className="btn btn-primary d-flex" onClick={(e) => handleUpdateUserProfile(e)} style={{ float: 'right' }}>Update {isUpdatingProfile ? <span className=' ms-2'><Circles
                                height="20"
                                width="20"
                                color="#ffffff"
                                ariaLabel="circles-loading"
                                visible={true}
                            /></span> : null}
                            </button>}
                            </div>
                        </div>
                        </div>
            </section>
            <ResetPassWordModal isResetModalOpen={isResetModalOpen} setResetModalOpen={setResetModalOpen} modalHeader='Reset Password' buttonLable='Reset' />

            </main>
    )
}


UserProfile.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    setFront: PropTypes.func,
    setBack: PropTypes.func,
}

UserProfile.defaulProps = {
    dispatch: noop,
    loader: PropTypes.bool,
    setFront: noop,
    setBack: noop,
}

function mapStateToProps() {
}
export default connect(mapStateToProps)(UserProfile)